<template>
	<v-title>
		<v-breadcrumbs :items="localizedBreadcrumbs" divider=">"></v-breadcrumbs>
	</v-title>
	<v-card class="main-card">
		<v-card-title class="ma-2">
			<div style="display: flex; justify-content: space-between">
				<div style="display: flex">
					<div class="mr-3">
						<v-icon color="#FF7E87 ">mdi-account-circle</v-icon>
					</div>
					<div>{{ $t('agent_information') }}</div>
				</div>
				<div style="display: flex">
					<div class="mr-5">
						<v-chip variant="flat" style="color: black" :class="agentDetails.active
							? 'active-status'
							: 'inactive-status'
							" density="default"><v-icon start icon="mdi-circle" :class="agentDetails.active
								? 'active-status-icon'
								: 'inactive-status-icon'
								"></v-icon>{{ agentDetails.active ? $t('Active') : $t('Inactive') }}
						</v-chip>
					</div>
					<div>
						<v-menu>
							<template v-slot:activator="{ props }">
								<v-icon class="mdi-dots-vertical" size="large"
									v-bind="props">mdi-clipboard-list-outline</v-icon>
							</template>

							<v-list style="
									cursor: pointer;
									margin-top: 10px;
									border-radius: 15px;
								" :close-on-content-click="true">
								<!-- Set close-on-content-click to true -->
								<v-list-item>
									<v-list-item-title @click="isEditProfileOpen = true">{{ $t('edit_agent_profile')
									}}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="resetPassword = true">
									<v-list-item-title>{{ $t('reset_agent_password') }}</v-list-item-title>
								</v-list-item>
								<v-divider></v-divider>

								<v-list-item>
									<v-list-item-title @click="logout">
										<div :class="agentDetails.active
											? 'inactive-status-icon'
											: 'active-status-icon'
											">
											<v-icon start icon="mdi-circle"></v-icon>{{
												agentDetails.active
													? 'Inactive agent'
													: 'Active agent'
											}}
										</div>
									</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
				</div>
			</div>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col cols="8">
					<v-row>
						<v-col cols="3">
							<div style="
									display: flex;
									align-items: center;
									justify-content: center;
								">
								<!-- <v-img
									class="bg-white"
									max-width="150px"
									max-height="120px"
									cover
									aspect-ratio="1:1"
									:src="agentDetails.pictureUrl"
									style="
										border-radius: 10px;
										border: 0.5px solid black;
									"
								></v-img> -->
								<v-avatar color="grey" size="150" class="ml-5" :image="agentDetails?.pictureUrl">
								</v-avatar>
							</div>
						</v-col>
						<v-col cols="8">

							<div>
								<div style="
										display: flex;
										justify-content: space-between;
									">
									<div class="agent-line-name">
										{{ $t('line_name') }}:
										{{ agentDetails.lineName || 'no name' }}
									</div>

									<div>
										<v-rating v-model="agentFeedback" empty-icon="mdi-star-outline"
											full-icon="mdi-star" half-icon="mdi-star-half" half-increments
											density="comfortable" class="pl-2" disabled color="yellow-darken-3">
										</v-rating>
									</div>
								</div>
								<div class="agentType">
									{{ $t('type') }}: {{ agentDetails?.roles?.[0]?.type || 'undefined' }}
								</div>
								<div class="agentName">
									{{ $t('name') }}:
									{{
										`${agentDetails.firstName} ${agentDetails.lastName} `
									}}
								</div>
								<div class="agent-contactNumber">
									{{ $t('contact_number') }} Number : {{ agentDetails.phone }}
								</div>
								<div class="agent-contactNumber">
									{{ $t('email') }} :
									{{ agentDetails.email }}
								</div>
								<div class="agent-approvedDate">
									{{ $t('approved_date') }} : {{ dateCreated }}
								</div>
								<div>
									<div style="display: flex">
										<div class="agent-nickname">
											{{ $t('aka_name') }} :
										</div>
										<div>{{ agentDetails.nickname }}</div>
									</div>
									<div style="display: flex">
										<div class="agent-contactTime">
											{{ $t('preferred_contact_time') }}:
										</div>
										<div>
											{{
												agentDetails.preferredContactTime
											}}
										</div>
									</div>
									<div style="display: flex">
										<div class="agent-availableTime">
											{{ $t('available_time') }} :
										</div>
										<div>
											{{ agentDetails.availableTime }}
										</div>
									</div>
									<div style="display: flex">
										<div class="agent-remote">{{ $t('able_to_work_remotely') }} :</div>
										<div>
											{{
												agentDetails.remote
													? 'Unavailable'
													: 'Available'
											}}
										</div>
									</div>
									<div>
										<div class="agent-location">
											{{ $t('base_location') }}
										</div>
										<div>{{ agentDetails.address }}</div>
									</div>
									<div class="agent-skillset my-2">
										{{ $t('skillset') }}
									</div>

									<div>
										<v-chip class="mr-2 mb-3 mb-md-0 text-white"
											v-for="skill in agentDetails.skills" :key="skill.id" density="default"
											:style="{
												'background-color':
													colorGenerator(
														skill.name || ''
													),
											}">{{ skill.name }}
										</v-chip>
									</div>
									<div class="agent-skillset my-2">
										{{ $t('certificate') }}
									</div>
									<div>
										<v-chip class="mr-2 mb-3 mb-md-0 text-white"
											v-for="certificate in agentDetails.agentCertificate" :key="certificate"
											:style="{
												'background-color':
													colorGenerator(
														certificate.certificateName
													),
												color: 'white',
											}">
											{{
												certificate.certificateName
											}}
										</v-chip>
									</div>
									<div class="d-flex justify-space-between mt-4">
										<div>
											<label for="title" style="font-weight: 600">{{ $t('certificate_file')
											}}</label>
										</div>
										<div style="
												color: rgba(255, 126, 135, 1);
												text-decoration: underline;
												cursor: pointer;
											" @click="downloadAllFiles">
											{{ $t('download_all_file') }}
										</div>
									</div>
									<div>
										<div v-for="(
												document, index
											) in agentDetails.agentDocument" :key="index" class="document-item">
											<div class="d-flex justify-space-between">
												<div class="d-flex">
													<div>
														<v-icon>mdi-file-outline</v-icon>
													</div>
													<div>
														{{ document.fileName }}
														<!-- {{
															truncateFileName(
																document.fileName
															)
														}} -->
													</div>
												</div>
												<div style="cursor: pointer" @click="
													downloadSingleFile(
														document
													)
													">
													<v-icon>mdi-download</v-icon>
												</div>
											</div>
										</div>
									</div>

									<div class="d-flex justify-space-between mt-4"
										v-if="agentDetails?.roles?.[0]?.type == 'esg'">
										<div>
											<label for="title" style="font-weight: 600">{{ $t('experience_information')
											}}</label>
										</div>
										<div style="
												color: rgba(255, 126, 135, 1);
												text-decoration: underline;
												cursor: pointer;
											" @click="downloadAllFiles">
											{{ $t('download_file') }}
										</div>
									</div>
									<div v-if="agentDetails?.roles?.[0]?.type == 'esg'">
										<div>
											<div class="my-2" style="font-weight: 600">
												{{ $t('experience_and_experience_in_operations') }}</div>
											<div
												v-if="agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.socialImpactAssessment?.year || agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.socialImpactAssessment?.expertise">
												<div>
													<p style="font-weight:500;">
														<li> {{ $t('creating') }} {{ $t('social_impact_assessment') }}
														</li>
													</p>
													<div class="ml-5">
														{{ $t('experience') }} : {{
															agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.socialImpactAssessment?.year
														}}
													</div>
													<div class="ml-5">
														{{ $t('level_of_expertise') }} : {{
															agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.socialImpactAssessment?.expertise
														}}
													</div>
												</div>


											</div>
											<div class="my-2"
												v-if="agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.sroi?.year || agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.sroi?.expertise">
												<div>
													<p style="font-weight:500;">
														<li>{{ $t('creating') }} {{ $t('writing_sroi_reports') }}
														</li>
													</p>
													<div class="ml-5">
														{{ $t('experience') }} : {{
															agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.sroi?.year
														}}
													</div>
													<div class="ml-5">
														{{ $t('level_of_expertise') }} : {{
															agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.sroi?.expertise
														}}
													</div>
												</div>


											</div>
											<div
												v-if="agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.speaker?.year || agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.speaker?.expertise">
												<div>
													<p style="font-weight:500;">
														<li>{{ $t('creating') }} {{ $t('speaker') }}</li>
													</p>
													<div class="ml-5">
														{{ $t('experience') }} : {{
															agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.speaker?.year
														}}
													</div>
													<div class="ml-5">
														{{ $t('level_of_expertise') }} : {{
															agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.speaker?.expertise
														}}
													</div>
												</div>


											</div>
											<div
												v-if="agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.consulting?.year || agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.consulting?.expertise">
												<div class="my-2">
													<p style="font-weight:500;">
														<li> {{ $t('creating') }} {{ $t('consulting_coaching_team') }}
														</li>
													</p>
													<div class="ml-5">
														{{ $t('experience') }} : {{
															agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.consulting?.year
														}}
													</div>
													<div class="ml-5">
														{{ $t('level_of_expertise') }} : {{
															agentDetails.userExperience?.metadata?.operationalExpertiseAndExperince?.consulting?.expertise
														}}
													</div>
												</div>


											</div>
										</div>
										<div class="my-2">
											<div style="font-weight:600">
												{{ $t('operational_experience_with_agencies') }}
											</div>
											<div>
												<div class="my-2"
													v-if="agentDetails.userExperience?.metadata?.organizationExperience?.government">
													<p style="font-weight:500;">
														<li> {{ $t('government') }}</li>
													</p>
													<div class="ml-5">

														{{ $t('frequency_level_of_the_work') }}
														:
														{{
															agentDetails.userExperience?.metadata?.organizationExperience?.government
														}}
													</div>
												</div>

												<div class="mb-2"
													v-if="agentDetails.userExperience?.metadata?.organizationExperience?.private">
													<p style="font-weight:500;">
														<li>{{ $t('private') }}</li>
													</p>
													<div class="ml-5">

														{{ $t('frequency_level_of_the_work') }}
														:
														{{
															agentDetails.userExperience?.metadata?.organizationExperience?.private
														}}
													</div>
												</div>
												<div class="mb-2"
													v-if="agentDetails.userExperience?.metadata?.organizationExperience?.society">
													<p style="font-weight:500;">
														<li>{{ $t('society') }}</li>
													</p>
													<div class="ml-5">

														{{ $t('frequency_level_of_the_work') }}
														:
														{{
															agentDetails.userExperience?.metadata?.organizationExperience?.society
														}}
													</div>
												</div>
												<div class="mb-2"
													v-if="agentDetails.userExperience?.metadata?.organizationExperience?.education">
													<p style="font-weight:500;">
														<li>{{ $t('education') }}</li>
													</p>
													<div class="ml-5">

														{{ $t('frequency_level_of_the_work') }}
														:
														{{
															agentDetails.userExperience?.metadata?.organizationExperience?.education
														}}
													</div>
												</div>

											</div>
										</div>
										<div>
											<div style="font-weight:600">
												{{ $t('select_expertise_skill') }}
											</div>
											<div
												v-if="agentDetails.userExperience?.metadata?.skillExpertise?.sustainableDevelopmentDimnesion?.length">
												<div style="font-weight: 500;">
													<li>{{ $t('sustainable_development_dimension') }}</li>
												</div>
												<div v-for="(item, index) in agentDetails.userExperience?.metadata?.skillExpertise?.sustainableDevelopmentDimnesion"
													class="ml-5">
													<li>{{ item }}</li>
												</div>
											</div>
											<div
												v-if="agentDetails.userExperience?.metadata?.skillExpertise?.impactAssessmentDimanesion.length">
												<div style="font-weight: 500;">
													<li>{{ $t('impact_assessment_dimension') }}</li>
												</div>
												<div v-for="(item, index) in agentDetails.userExperience?.metadata?.skillExpertise?.impactAssessmentDimanesion"
													class="ml-5">
													<li>{{ item }}</li>
												</div>
											</div>
											<div
												v-if="agentDetails.userExperience?.metadata?.skillExpertise?.organizationalManagementDimension.length">
												<div style="font-weight: 500;">
													<li>{{ $t('organizational_management_dimension') }}</li>
												</div>
												<div v-for="(item, index) in agentDetails.userExperience?.metadata?.skillExpertise?.organizationalManagementDimension"
													class="ml-5">
													<li>{{ item }}</li>

												</div>
												<div class="ml-5"
													v-if="agentDetails.userExperience?.metadata?.skillExpertise?.otherText">
													<li>
														{{
															agentDetails.userExperience?.metadata?.skillExpertise?.otherText
														}}
													</li>
												</div>


											</div>
										</div>
									</div>



								</div>
							</div>
						</v-col>
					</v-row>
				</v-col>
				<v-divider vertical style="min-height: 85vh"></v-divider>
				<v-col cols="4">
					<div style="
							display: flex;
							justify-content: space-between;
							flex-direction: column;
							padding: 10px;
						">
						<div v-if="agentFeedbackList.length">
							<div class="d-flex justify-space-between">
								<div style="font-weight: 600; font-size: 20px">
									{{ $t('working_history') }}
								</div>

								<div @click="workingDialog = true" style="cursor: pointer">
									{{ $t('see_all') }} >
								</div>
							</div>
							<div>
								<div v-for="(
										workHistory, index
									) in recentUserHistories" :key="index" class="pa-1">
									<div style="
											border: 1px solid #dddddd;
											padding: 10px;
											border-radius: 15px;
											margin: 5px;
										" @click="
											workIncident(
												workHistory.incident.id
											)
											">
										<div class="d-flex justify-space-between align-center">
											<div class="text-grey-darken-2">
												{{
													workHistory.incident?.title
												}}
											</div>
										</div>
										<div class="d-flex justify-space-between align-center">
											<div class="text-grey">
												{{
													formatDate(
														workHistory.updatedAt
													)
												}}
											</div>

											<div class="ma-3">
												<v-rating v-if="
													workHistory.incident
														.agentFeedbacks
														.length > 0
												" :model-value="workHistory.incident
													.agentFeedbacks[0]
													.overallRating
													" size="small" density="compact" color="#FBC816" readonly></v-rating>
												<span v-else>{{ $t('no_rating') }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="userStatusHistories.length" style="
							display: flex;
							justify-content: space-between;
							flex-direction: column;
							padding: 10px;
						">
						<div class="d-flex justify-space-between">
							<div style="font-weight: 600; font-size: 20px">
								{{ $t('status_history') }}
							</div>
							<div @click="statusDialog = true" style="cursor: pointer">
								{{ $t('see_all') }} >
							</div>
						</div>
						<div v-for="(
								statusHistory, index
							) in recentStatusHistories" :key="index" class="pa-1">
							<div style="
									border: 1px solid #dddddd;
									padding: 10px;
									border-radius: 15px;
									margin: 5px;
								">
								<div class="d-flex justify-space-between">
									<div>
										<v-chip variant="flat" :class="statusHistory.status ===
											'active' ||
											statusHistory.status ===
											'approve'
											? 'active-status'
											: 'inactive-status'
											" density="default">
											<v-icon start icon="mdi-circle" :class="statusHistory.status ===
												'active' ||
												statusHistory.status ===
												'approve'
												? 'active-status-icon'
												: 'inactive-status-icon'
												"></v-icon>
											{{
												statusHistory.status ===
													'active' ||
													statusHistory.status ===
													'approve'
													? $t('Active')
													: $t('Inactive')
											}}
										</v-chip>
									</div>
									<div class="mt-1">
										{{
											formatDate(statusHistory.createdAt)
										}}
									</div>
								</div>
								<div class="ma-3">
									{{ statusHistory.reason }}
								</div>
							</div>
						</div>
					</div>
				</v-col>
			</v-row>
		</v-card-text>
		<v-dialog v-model="resetPassword" width="450">
			<v-card>
				<v-card-text>
					<div class="text-center text-h5 font-weight-bold">
						{{ $t('confirm_reset_agent_password') }}
					</div>
					<div class="d-flex justify-center my-5">
						<v-avatar :image="agentDetails?.pictureUrl" size="100"></v-avatar>
						<div class="ml-10">
							<div class="agent-line-name">
								{{ $t('line)name') }} :
								{{ agentDetails.lineName || 'no name' }}
							</div>
							<div class="agentName">
								{{ $t('name') }}:
								{{
									`${agentDetails.firstName} ${agentDetails.lastName} `
								}}
							</div>
							<div class="agentSpecialization">
								{{ agentDetails.specialization }}
							</div>
						</div>
					</div>
				</v-card-text>
				<v-card-footer class="d-flex justify-space-between bg-black pa-3">
					<v-btn class="bg-black font-weight-bold" @click="resetPassword = false">{{ $t('cancel') }}</v-btn>
					<v-btn class="bg-black text-green-accent-4 font-weight-bold"
						@click="resetAgentPassword(agentDetails.id)">{{
							$t('confirm') }}</v-btn>
				</v-card-footer>
			</v-card>
		</v-dialog>
		<v-dialog width="400" v-model="showPassword" persistent>
			<v-card>
				<v-card-text>
					<div class="font-weight-bold text-h6 d-flex justify-center ma-2">
						Default password
						<span class="text-red-lighten-2 ml-2">"ProSp@ce+"</span>
					</div>
				</v-card-text>
				<v-card-footer class="d-flex flex-row-reverse">
					<v-btn class="ma-2 font-weight-bold" elevation="0" @click="showPassword = false">Cancel</v-btn>
				</v-card-footer>
			</v-card>
		</v-dialog>

		<v-dialog width="700" v-model="workingDialog">
			<v-card style="border-radius: 15px">
				<v-card-header class="d-header d-flex justify-space-between bg-black text-white pa-4">
					<div style="font-weight: bold">{{ $t('working_history') }}</div>
					<v-icon @click="workingDialog = false">mdi-close-circle</v-icon>
				</v-card-header>
				<v-card-text>
					<div>
						<v-row align="center my-1">
							<v-col cols="">
								<div style="font-size: 20px; font-weight: 600">
									{{ $t('status') }} ({{ agentFeedbackList.length }})
								</div>
							</v-col>

							<v-col>
								<div class="search-bar">
									<v-text-field variant="outlined" rounded density="compact"
										prepend-inner-icon="mdi-magnify" placeholder="ค้นหา incident..."
										hide-details="" />
								</div>
							</v-col>
						</v-row>

						<div>
							<div v-for="(
									workHistory, index
								) in paginatedWorkingHisotories" :key="index" class="pa-1">
								<div style="
										border: 1px solid #dddddd;
										padding: 10px;
										border-radius: 15px;
										margin: 5px;
									" @click="
										workIncident(workHistory.incidentId)
										">
									<div class="d-flex justify-space-between align-center">
										<div class="text-grey-darken-2">
											{{ workHistory.incident?.title }}
										</div>
									</div>
									<div class="d-flex justify-space-between align-center">
										<div class="text-grey">
											{{
												formatDate(
													workHistory.updatedAt
												)
											}}
										</div>

										<div class="ma-3">
											<v-rating v-if="
												workHistory.incident
													.agentFeedbacks.length >
												0
											" :model-value="workHistory.incident
												.agentFeedbacks[0]
												.overallRating
												" size="small" density="compact" color="#FBC816" readonly></v-rating>
											<span v-else>No rating</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<v-pagination v-model="currentHistoryPage" :length="totalHistoryPage" circle></v-pagination>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="statusDialog" width="700">
			<v-card style="border-radius: 15px">
				<v-card-header class="d-header d-flex justify-space-between bg-black text-white pa-4">
					<div style="font-weight: bold">{{ $t('status_history') }}</div>
					<v-icon @click="statusDialog = false">mdi-close-circle</v-icon>
				</v-card-header>
				<v-card-text>
					<div>
						<div style="font-size: 20px; font-weight: 600">
							{{ $t('status') }}({{ userStatusHistories.length }})
						</div>
						<div>
							<div v-for="(
									statusHistory, index
								) in paginatedStatusHistories" :key="index" class="pa-1">
								<div style="
										border: 1px solid #dddddd;
										padding: 10px;
										border-radius: 15px;
										margin: 5px;
									">
									<div class="d-flex justify-space-between">
										<div>
											<v-chip variant="flat" :class="statusHistory.status ===
												'active' ||
												statusHistory.status ===
												'approve'
												? 'active-status'
												: 'inactive-status'
												" density="default">
												<v-icon start icon="mdi-circle" :class="statusHistory.status ===
													'active' ||
													statusHistory.status ===
													'approve'
													? 'active-status-icon'
													: 'inactive-status-icon'
													"></v-icon>
												{{
													statusHistory.status ===
														'active' ||
														statusHistory.status ===
														'approve'
														? $t('Active')
														: $t('Inactive')
												}}
											</v-chip>
										</div>
										<div class="mt-1">
											{{
												formatDate(
													statusHistory.createdAt
												)
											}}
										</div>
									</div>
									<div class="ma-3">
										{{ statusHistory.reason }}
									</div>
								</div>
							</div>
						</div>
						<v-pagination v-model="currentPage" :length="totalStatusPage" circle></v-pagination>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="isEditProfileOpen" width="750">
			<edit-profile :agent-details="agentDetails" @closeDialog="isEditProfileOpen = false"
				@emitUpdateAgentProfile="updateAgentProfile" />
		</v-dialog>

		<v-snackbar v-model="snackbar" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">Profile has been saved .</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="snackbar = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
	</v-card>
</template>

<script>
import EditUserProfile from '@/components/EditUserProfile.vue'
import agentService from '@/services/API/agentService'
import agentHistory from '@/services/API/agentHistory.js'
import moment from 'moment'
import IncidentDetail from './IncidentDetail.vue'
export default {
	components: {
		'edit-profile': EditUserProfile,
	},
	data: () => ({
		agentDetails: {},
		userStatusHistories: [],
		dateCreated: '',
		snackbar: false,
		isEditProfileOpen: false,
		agentFeedback: '',
		agentFeedbackList: [],
		currentPage: 1,
		itemsPerPage: 5,
		currentHistoryPage: 1,
		itemsPerHistoryPage: 5,
		statusDialog: false,
		workingDialog: false,
		resetPassword: false,

		showPassword: false,

		prospace_breadcrums: [
			{
				title: 'Verified agent',
				disabled: false,
				href: '/agent-list/verified-agent',
			},
			{
				title: 'Agent Infromation',
				disabled: true,
				href: 'breadcrumbs_link_1',
			},
		],
	}),
	created() {
		this.fetchAgentList()
	},
	computed: {
		localizedBreadcrumbs() {
			return [
				{ title: this.$t('verified_agent'), disabled: false, color: 'grey', href: '/agent-list/verified-agent' },
				{ title: this.$t('agent_information'), color: 'black', disabled: false }
			];
		},
		recentStatusHistories() {
			// Assuming createdAt is a date string that needs to be parsed as a date object
			// Sort by date in descending order and then slice the first four
			return this.userStatusHistories
				.slice() // create a copy to avoid mutating the original array
				.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // sort descending
				.slice(0, 4) // get the first four items
		},
		recentUserHistories() {
			// Assuming createdAt is a date string that needs to be parsed as a date object
			// Sort by date in descending order and then slice the first four

			return this.agentFeedbackList
				.slice() // create a copy to avoid mutating the original array
				.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // sort descending
				.slice(0, 3) // get the first four items
		},
		paginatedStatusHistories() {
			const start = (this.currentPage - 1) * this.itemsPerPage
			const end = start + this.itemsPerPage
			return this.userStatusHistories.slice(start, end)
		},
		paginatedWorkingHisotories() {
			const start =
				(this.currentHistoryPage - 1) * this.itemsPerHistoryPage
			const end = start + this.itemsPerHistoryPage
			return this.agentFeedbackList.slice(start, end)
		},
		totalStatusPage() {
			return Math.ceil(
				this.userStatusHistories.length / this.itemsPerPage
			)
		},
		totalHistoryPage() {
			return Math.ceil(
				this.agentFeedbackList.length / this.itemsPerHistoryPage
			)
		},
	},

	methods: {
		truncateFileName(fileName) {
			// If the file name is longer than 15 characters, truncate and add ellipsis
			return fileName.length > 15
				? fileName.slice(0, 15) + '...'
				: fileName
		},
		downloadAllFiles() {
			if (
				this.agentDetails.agentDocument &&
				this.agentDetails.agentDocument.length > 0
			) {
				this.agentDetails.agentDocument.forEach((url, index) => {
					setTimeout(() => {
						const link = document.createElement('a')
						link.href = url.documentUrl
						link.download = url.fileName || `file-${index + 1}` // Use filename or a fallback
						link.target = '_blank'

						document.body.appendChild(link)
						link.click()
						document.body.removeChild(link)
					}, index * 500) // 500ms delay between each download
				})
			}
		},
		downloadSingleFile(url) {
			const link = document.createElement('a')
			link.href = url.documentUrl
			link.download = url.fileName // Use the filename provided by the server if available
			// Set target="_blank" to open the file in a new tab
			link.target = '_blank'

			// Append the anchor to the body
			document.body.appendChild(link)

			// Trigger the download
			link.click()

			// Remove the anchor from the document
			document.body.removeChild(link)
		},
		async updateAgentProfile(obj) {
			// convert all elements of updateObj.skills to lower case
			obj.skills = obj.skills.map((skill) => skill.toLowerCase())

			// Remove duplicates using Set and convert back to an array
			obj.skills = Array.from(new Set(obj.skills))
			await agentService
				.updateAgentProfile(
					obj.id,
					obj /** send the payload */,
					obj.pictureUrl
				)
				.then(() => {
					this.fetchAgentList()
					this.snackbar = true
				})
				.catch((err) => {
					console.log(err)
				})
		},
		async fetchAgentList() {
			this.isFetchingAgents = true
		},
		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) *
					16777215
				)
			).toString(16)
			return `#${hex}`
		},
		workIncident(id) {
			const agentDetail = `/incident-detail?incidentId=${id}`
			window.open(agentDetail, '_blank')
		},
		async resetAgentPassword(id) {
			await agentService.resetAgentPassword(id).then((response) => {
				if (response.status == 200) {
					this.resetPassword = false
					this.showPassword = true
				}
			})
		},
		async getUserStatusHistory() {
			await agentHistory
				.getStatusHistory(this.$route.query.agentId)
				.then((response) => {
					if (response.status == 200) {
						this.userStatusHistories =
							response.data.data.userStatusHistories
					}
				})
		},
		async getUserWorkingHistory() {
			await agentHistory
				.getWorkingHistory(this.$route.query.agentId)
				.then((response) => {
					if (response.status == 200) {
						this.agentFeedbackList = response.data.data.application
					}
				})
		},
		formatDate(date) {
			return moment(date).format('DD MMM, YYYY')
		},
	},

	async created() {
		this.getUserWorkingHistory()
		this.getUserStatusHistory()
		await agentService
			.getSingleAgent(this.$route.query.agentId)
			.then((response) => {
				this.dateCreated = moment(
					this.agentDetails.updatedAt,
					'YYYY-MM-DD HH:mm:ss'
				).format('DD MMM, YYYY')
				this.agentDetails = response.data
				this.showEditUserProfile = true
			})
		this.agentFeedback = this.agentDetails.agentFeedback.AgentFeedback
		this.dateCreated = moment(
			this.agentDetails.updatedAt,
			'YYYY-MM-DD HH:mm:ss'
		).format('MMMM D, YYYY, h:mm A')
	},
}
</script>

<style>
.main-card {
	width: 100%;
	min-height: 90vh;
}

.agent-line-name {
	display: flex;
	align-items: center;
	font-weight: 600;
	font-size: 20px;
}

.agent-contactNumber,
.agentName,
.agentEmail,
.agentSpecialization,
.agent-approvedDate {
	font-size: 14px;
	margin-bottom: 5px;
}

.agent-skillset,
.agent-nickname,
.agent-contactTime,
.agent-availableTime,
.agent-remote,
.agent-preferredTime {
	font-size: 14px;
	margin-bottom: 5px;
	font-weight: 600;
	margin-right: 5px;
}

.agent-location {
	font-size: 14px;
	margin-top: 7px;
	font-weight: 600;
	margin-right: 5px;
}

.active-status {
	background-color: #d3f9dc;
	padding: 10px;
	width: 100px;
	display: flex;
	color: #000;
	justify-content: center;
	font-weight: 500;
}

.active-status-icon {
	color: #12c138;
	font-size: 10px;
}

.inactive-status-icon {
	color: #ff2331;
	font-size: 10px;
}

.inactive-status {
	background-color: #ffc2c6;
	color: black;
	padding: 10px;
	width: 100px;
	text-align: center;
	display: flex;
	justify-content: center;
	font-weight: 500;
}

.pl-2 .v-icon {
	font-size: 30px;
	/* Adjust the size of the icons as needed */
}

.custom-dialog .v-dialog__content {
	overflow-y: auto;
}

.custom-dialog .v-dialog__content::-webkit-scrollbar {
	display: none;
	/* For Chrome, Safari, and Opera */
}

.custom-dialog .v-dialog__content {
	-ms-overflow-style: none;
	/* IE and Edge */
	scrollbar-width: none;
	/* Firefox */
}

.document-item {
	width: 100%;
	/* Adjusts width to accommodate 2 items per row with some spacing */
	border: 1px solid rgba(153, 153, 153, 1);
	border-radius: 20px;
	padding: 10px;
	margin: 10px;
}
</style>
